import LoaderIcon from './component'

export default LoaderIcon
